// src/constants/roleBasedRoutes.js
import { Components, Paths, UserRoles } from "../constants/enums";

const roleBasedRoutes = {
  [UserRoles.ADMIN]: [
    {
      path: Paths.EXECUTIVE_SUMMARY,
      component: Components.EXECUTIVE_DASHBOARD,
    },
    { path: Paths.ADMIN_DASHBOARD, component: Components.ADMIN_DASHBOARD },
    {
      path: Paths.ONBOARDED_CUSTOMERS,
      component: Components.ONBOARDED_CUSTOMERS,
    },
    {
      path: Paths.APPROVAL_LEVEL_ASSIGNMENT,
      component: Components.LEVELS_MANAGEMENT_PAGE,
    },
    {
      path: Paths.DISPUTE_LEVEL_ASSIGNMENT,
      component: Components.DISPUTE_LEVELS_MANAGEMENT_PAGE,
    },
    {
      path: Paths.CUSTOMER_HERARCHY_LEVEL,
      component: Components.CUSTOMER_HERARCHY_LEVEL,
    },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },

    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.ROLE, component: Components.ROLE },
    { path: Paths.DEPARTMENT, component: Components.DEPARTMENT },
    { path: Paths.DESIGNATION, component: Components.DESIGNATION },
    { path: Paths.PRIVILEGE, component: Components.PRIVILEGE },
    { path: Paths.USERPRIVILEGE, component: Components.USERPRIVILEGE },
    { path: Paths.USERS, component: Components.EMPLOYEE },
    { path: Paths.BUSINESS_UNIT, component: Components.BUSINESS_UNIT },
    { path: Paths.CUSTOMER_TYPE, component: Components.CUSTOMER_TYPE },
    { path: Paths.CUSTOMER_REGION, component: Components.CUSTOMER_REGION },
    {
      path: Paths.SUBCUSTOMER_REGION,
      component: Components.SUBCUSTOMER_REGION,
    },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMERS_HERARCHICAL,
      component: Components.CUSTOMERS_HIERARCHY,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
    {
      path: Paths.PROMOTION,
      component: Components.PROMOTION,
    },
    {
      path: Paths.BULK_UPLOAD,
      component: Components.BULK_UPLOAD,
    },
    {
      path: Paths.ROLEPRIVILEGE,
      component: Components.ROLEPRIVILEGE,
    },
    
  ],

  [UserRoles.SALES_MANAGER]: [
    { path: Paths.SELLER_DASHBOARD, component: Components.DASHBOARD },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.REGIONAL_MANAGER]: [
    { path: Paths.SALES_MANAGER_DASHBOARD, component: Components.DASHBOARD },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.MARKETING_HEAD]: [
    { path: Paths.SELLER_DASHBOARD, component: Components.DASHBOARD },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.CUSTOMER_SERVICE]: [
    { path: Paths.CUSTOMER_SERVICE_DASHBOARD, component: Components.DASHBOARD },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.VP_SALES]: [
    { path: Paths.SALES_MANAGER_DASHBOARD, component: Components.DASHBOARD },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.CFO]: [
    {
      path: Paths.ADMIN_DASHBOARD,
      component: Components.ADMIN_DASHBOARD,
    },
    {
      path: Paths.EXECUTIVE_SUMMARY,
      component: Components.EXECUTIVE_DASHBOARD,
    },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.CCSUPERVISOR]: [
    { path: Paths.CC_SUPERVISOR_DASHBOARD, component: Components.DASHBOARD },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    { path: Paths.PAYMENTS, component: Components.PAYMENTS },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.DISPUTE_DETAILS, component: Components.DISPUTE_DETAILS },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.CUSTOMER]: [
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    {
      path: Paths.CUSTOMER_DASHBOARD,
      component: Components.CUSTOMER_DASHBOARD,
    },
    { path: Paths.INVOICES, component: Components.INVOICE_CUSTOMER },
    { path: Paths.PAYMENT_CUSTOMER, component: Components.PAYMENTS_CUSTOMER },
    { path: Paths.LOGISTIC_CUSTOMER, component: Components.LOGISTIC_DETAILS },
    { path: Paths.DISPUTE_DETAILS, component: Components.DISPUTE_DETAILS },
    {
      path: Paths.CREDIT_LINE_REQUEST,
      component: Components.CREDIT_LINE_DETAILS,
    },
    {
      path: Paths.VIEW_ACCOUNT_STATMENT,
      component: Components.VIEW_ACCOUNT_STATMENT,
    },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
  ],

  [UserRoles.LOGISTIC_MANAGER]: [
    {
      path: Paths.LOGISTIC_SUPERVISOR_DASHBOARD,
      component: Components.DASHBOARD,
    },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.LOGISTIC_SUPERVISOR]: [
    {
      path: Paths.LOGISTIC_SUPERVISOR_DASHBOARD,
      component: Components.DASHBOARD,
    },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.LOGISTIC_RESPONSIBLE]: [
    {
      path: Paths.LOGISTIC_SUPERVISOR_DASHBOARD,
      component: Components.DASHBOARD,
    },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.CEO]: [
    {
      path: Paths.EXECUTIVE_SUMMARY,
      component: Components.EXECUTIVE_DASHBOARD,
    },
    {
      path: Paths.ADMIN_DASHBOARD,
      component: Components.ADMIN_DASHBOARD,
    },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.CC_MANAGER]: [
    { path: Paths.CC_MANAGER_DASHBOARD, component: Components.DASHBOARD },
    {
      path: Paths.CUSTOMER_PAYMENTS,
      component: Components.VIEW_PAYMENT_DETAILS,
    },
    {
      path: Paths.INVOICES,
      component: Components.VIEW_INVOICE_AND_CREDIT_NOTE_DETAILS,
    },
    { path: Paths.LOGISTIC, component: Components.VIEW_LOGISTIC_DETAILS },
    { path: Paths.RAISED_DISPUTE, component: Components.RAISED_DISPUTE },
    { path: Paths.APPROVAL_CUSTOMER, component: Components.APPROVAL_CUSTOMER },
    { path: Paths.CREDIT_LINE, component: Components.CREDIT_LINE_CUSTOMER },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    {
      path: Paths.CUSTOMER_ACCOUNT_STATMENT,
      component: Components.ACCOUNT_STATEMENT_DETAILS,
    },
    {
      path: Paths.CUSTOMER_PRICE_LIST,
      component: Components.CUSTOMER_PRICE_LIST,
    },
    {
      path: Paths.CUSTOMER_BACK_ORDER,
      component: Components.CUSTOMER_BACK_ORDER,
    },
  ],

  [UserRoles.MARKETING_MANAGER]: [
    { path: Paths.MARKETINGMANAGER_DASHBOARD, component: Components.DASHBOARD },
    { path: Paths.MY_PROFILE, component: Components.USER_PROFILE },
    { path: Paths.USER_GUIDE, component: Components.USER_GUIDE_LIST },
    { path: Paths.CUSTOMER_FEEDBACK, component: Components.CUSTOMER_FEEDBACK },
  ],

  // Fallback role if role is not assigned or unknown
  [UserRoles.DEFAULT]: [
    {
      path: Paths.UNKNOWN_ROLE,
      component: Components.REDIRECT_TO_ROLE_DASHBOARD,
    },
  ],
};

export { roleBasedRoutes };
